<template>
    <footer class="footer has-cards">
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                
                <div class="col-lg-4">
                    <h4 class="text-primary font-weight-heavy mb-2">Nosso Endereço</h4>
                    <h5 class="mb-0 font-weight-light">Rua Paulo de Paula Lopes, 108</h5>
                    <h5 class="mb-0 font-weight-light">Poço da Panela - Recife - PE</h5>
                </div>
                 <div class="col-lg-3">
                </div>
                <div class="col-lg-3 text-lg-center btn-wrapper">
                    <h4 class="text-primary font-weight-light mb-2">81 4141-8193</h4>
                    <h4 class="text-primary font-weight-light mb-2">81 99692-3377</h4>
                    <!--<a target="_blank" rel="noopener" href="https://twitter.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-instagram btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://dribbble.com/creativetim"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://github.com/creativetimofficial"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a>-->
                </div>
                <div class="col-lg-2 text-lg-center btn-wrapper">
                    <h7 class="text-primary font-weight-light text-center">Empresa Credenciada:</h7>
                    <img class="img-fluid" src="img/brand/cra-pe.png" alt="cra">
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                </div>
                <div class="col-md-4">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="https://recifeadminsitradora.com.br" target="_blank" rel="noopener">Recife Administradora</a> & <a href="https://www.creative-tim.com" target="_blank" rel="noopener">Creative Tim</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
